import throttle from 'lodash/throttle';
import { Controller } from 'stimulus';

export default class extends Controller {
  state = {
    staticHeader: false,
  };

  initialize() {
    const bodyClasses = document.body.classList;

    if (this.isGenericDetailsPage()) return;

    if (this.isStaticHeaderPage()) {
      this.state.staticHeader = true;
      bodyClasses.add('-page-scrolling');
      return;
    }

    // Bind and throttle the scroll handler
    this.pagescroll = throttle(this.pagescroll.bind(this), 250);
    window.addEventListener('scroll', this.pagescroll);
  }

  isGenericDetailsPage() {
    return document.body.classList.contains('body__generic--details');
  }

  isStaticHeaderPage() {
    const bodyClasses = document.body.classList;
    return (
      bodyClasses.contains('template--hotels_faq') ||
      bodyClasses.contains('template--careers_single')
    );
  }

  toggle() {
    const navToggle = document.querySelector('.js-nav-toggle');
    navToggle.classList.toggle('site__nav--toggle-checked');
    const expanded = navToggle.getAttribute('aria-expanded');
    navToggle.setAttribute('aria-expanded', !expanded);
    this.toggleBodyLocked();
  }

  toggleBodyLocked() {
    const body = document.body;
    body.classList.toggle('-body-locked');

    if (this.state.staticHeader) return;

    if (body.classList.contains('-body-locked')) {
      body.classList.remove('-page-scrolling');
    } else {
      this.pagescroll();
    }
  }

  pagescroll() {
    if (document.body.classList.contains('notransition')) return;

    const body = document.body;
    const header = document.querySelector('.site__header');
    const footer = document.querySelector('.site-footer');
    const viewportTop = window.scrollY;
    const viewportBot = viewportTop + window.innerHeight;

    // Page has started scrolling
    const isScrolling = viewportTop > 20;
    body.classList.toggle('-page-scrolling', isScrolling);
    header.classList.toggle('-page-scrolling', isScrolling);

    // Page is at the bottom
    const nearBottom = viewportBot >= footer.offsetTop;
    body.classList.toggle('-page-bottom', nearBottom);
  }
}
